// extracted by mini-css-extract-plugin
module.exports = {"paymentColumn":"PaymentPage_paymentColumn__3Cd8Q","paymentContainer":"PaymentPage_paymentContainer__2qUgG"};